import {Model} from '@vuex-orm/core';
import User from '../../users/models/User';
import TaskAssignment from '../../tasks/models/TaskAssignment';
import {Course, CourseSection} from '@/courses/models';
import CourseLikeAssignment from './CourseLikeAssignment';
import {Joined} from '@/orm/types/Joined';
import Fields from '@vuex-orm/core/lib/model/contracts/Fields';
import {RawAssignment} from '@/assignments/types/RawAssignment';

/**
 * Assignment class
 */
export class Assignment
  extends Model
  implements Omit<RawAssignment, 'createdBy' | 'taskAssignments'>
{
  static entity = 'Assignment';

  id!: number;
  name!: string;
  courseId!: number;
  course!: Joined<Course>;
  ownerId!: number;
  owner!: Joined<CourseSection>;
  createdAt!: string;
  createdById!: number | null;
  createdBy!: Joined<User>;
  taskAssignments!: Joined<TaskAssignment[]>;
  courseLikeAssignments!: Joined<CourseLikeAssignment[]>;
  overviewText!: string | null;

  static fields(): Fields {
    return {
      id: this.number(null),
      name: this.string(''),
      courseId: this.number(null),
      course: this.belongsTo(Course, 'courseId'),
      ownerId: this.number(null),
      owner: this.belongsTo(CourseSection, 'ownerId'),
      createdAt: this.string(''),
      createdById: this.number(null).nullable(),
      createdBy: this.belongsTo(User, 'createdById'),
      taskAssignments: this.hasMany(TaskAssignment, 'assignmentId'),
      courseLikeAssignments: this.hasMany(CourseLikeAssignment, 'assignmentId'),
      overviewText: this.string('').nullable(),
    };
  }
}

export default Assignment;
